import type { ProfileField } from "@/types/auth.types";

const PROFILE_FIELDS: readonly ProfileField[] = ["gender", "country"];

/** `missingProfileFields` as sent by the backend, unknown names dropped. */
export function toProfileFields(value: unknown): ProfileField[] | undefined {
  if (!Array.isArray(value)) return undefined;
  return value.filter((field): field is ProfileField => PROFILE_FIELDS.includes(field as ProfileField));
}
